import * as React from 'react';

export interface IOffersSettingsProps {
}

export function OffersSettings(props: IOffersSettingsProps) {
    return (
        <div className="text-left mt-8 ">
            <h1 className="text-xl sm:text-2xl xl:text-3xl font-extrabold text-cusBlack dark:text-white">Offer Settings</h1>
            <p className="text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2">Set a minimum offer for collections to ignore low offers.</p>


            <div className="lightBlueBg flex justify-center items-center flex-col w-full rounded-md py-14 mt-6 sm:mt-8">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-12 md:w-auto" width={67} height={67} viewBox="0 0 67 67">
                    <g id="Layer_1" transform="translate(-1 -1)">
                        <path id="Path_1175" data-name="Path 1175" d="M34.5,1A33.5,33.5,0,1,0,68,34.5,33.512,33.512,0,0,0,34.5,1Zm0,53.6a4.467,4.467,0,1,1,4.467-4.467A4.48,4.48,0,0,1,34.5,54.6Zm5.114-34.639-1.5,17.911a3.631,3.631,0,0,1-7.236,0l-1.5-17.911a5.134,5.134,0,1,1,10.251-.424,2.7,2.7,0,0,1-.022.424Z" fill="#262352" />
                    </g>
                </svg>
                <h4 className="text-cusBlack dark:text-white text-base md:text-xl mt-4">No collections to manage offers</h4>
                <p className="text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2 w-10/12 text-center">You currently don’t have any collections and items to manage offers.</p>

            </div>

        </div>
    );
}
